import { useTranslations } from "next-intl";
import { useTunnelSteps } from "@hooks/use-tunnel-steps";
import { usePrice } from "@hooks/use-prices";
import redeemTypes from "@utils/constants/redeemTypes";

function CouponMessage() {
  const t = useTranslations("common");

  const { coupon, couponToApply, discountType } = useTunnelSteps();
  const price = usePrice();

  const name = coupon?.first_name || t("coupon_message.a_friend");
  const durationInMonthsInt = parseInt(couponToApply?.duration_in_months, 10) || 1;
  const durationInMonthsStr = t("coupon_message.coupon_count_months", {
    count: durationInMonthsInt,
  });

  switch (couponToApply?.duration) {
    case "forever":
      if (couponToApply?.type === redeemTypes.couponPercentOff) {
        if (couponToApply?.value === 100) {
          return t(`coupon_message.${discountType}.promo_code_100_percent_off_forever`, {
            name,
          });
        }

        return t(`coupon_message.${discountType}.promo_code_percent_off_forever`, {
          percent: couponToApply?.value,
          name,
        });
      }
      if (couponToApply.type === redeemTypes.couponAmountOff) {
        return t(`coupon_message.${discountType}.promo_code_amount_off_forever`, {
          amount: price(couponToApply.value, { withoutCents: true, withoutSpace: true }),
          name,
        });
      }
      break;
    case "once":
    case "repeating":
      if (couponToApply.type === redeemTypes.couponPercentOff) {
        if (couponToApply.value === 100) {
          return t(`coupon_message.${discountType}.promo_code_100_percent_off`, {
            count: durationInMonthsInt,
            durationInMonths: durationInMonthsStr,
            name,
          });
        }

        return t(`coupon_message.${discountType}.promo_code_percent_off`, {
          count: durationInMonthsInt,
          durationInMonths: durationInMonthsStr,
          percent: couponToApply?.value,
          name,
        });
      }
      if (couponToApply?.type === redeemTypes.couponAmountOff) {
        return t(`coupon_message.${discountType}.promo_code_amount_off`, {
          count: durationInMonthsInt,
          durationInMonths: durationInMonthsStr,
          amount: price(couponToApply.value, { withoutCents: true, withoutSpace: true }),
          name,
        });
      }
  }
}

export default CouponMessage;
